import {
  REQUEST_RECIPE_SUGGESTION_REQUEST,
  REQUEST_RECIPE_SUGGESTION_SUCCESS,
  REQUEST_RECIPE_SUGGESTION_ERROR,
  RELOAD_RECIPE_SUGGESTION_REQUEST,
  RELOAD_RECIPE_SUGGESTION_SUCCESS,
  CANCEL_RECIPE_SUGGESTION_REQUEST,

  FETCH_RECIPE_SUGGESTION_REQUEST,
  FETCH_RECIPE_SUGGESTION_SUCCESS,
  FETCH_RECIPE_SUGGESTION_ERROR,

  FETCH_RECIPE_DETAIL_REQUEST,
  FETCH_RECIPE_DETAIL_SUCCESS,
  FETCH_RECIPE_DETAIL_ERROR,
  
  RESET_RECIPE_SUGGESSTION,
  UPDATE_FAVORITE,

  IRequestRecipeSuggestionRequest,
  IRequestRecipeSuggestionResponse,
  RequestRecipeSuggestionRequestAction,
  RequestRecipeSuggestionSuccessAction,
  RequestRecipeSuggestionErrorAction,

  IFetchRecipeSuggestionRequest,
  IFetchRecipeSuggestionResponse,
  IFetchRecipeSuggestionRequestAction,
  IFetchRecipeSuggestionSuccessAction,
  IFetchRecipeSuggestionErrorAction,
  IReloadRecipeSuggestionRequestAction,

  IFetchRecipeDetailRequest,
  IFetchRecipeDetailResponse,
  IFetchRecipeDetailRequestAction,
  IFetchRecipeDetailSuccessAction,
  IFetchRecipeDetailErrorAction,
  
  IResetRecipeAction,
  
  IUpdateFavorite,
  IUpdateFavoriteAction,
  ISearchRecipeRequestAction,
  ISearchRecipeSuccessAction,
  ISearchRecipeErrorAction,
  SEARCH_RECIPE_REQUEST,
  SEARCH_RECIPE_SUCCESS,
  SEARCH_RECIPE_ERROR,

  IResetSearchRecipeAction,
  RESET_SEARCH_RECIPE,
  SEARCH_AI_RECIPE_REQUEST,
  SEARCH_AI_RECIPE_SUCCESS,
  SEARCH_AI_RECIPE_ERROR,
  ISearchAiRecipeRequestAction,
  ISearchAiRecipeSuccessAction,
  ISearchAiRecipeErrorAction,
} from './types';

// create recipe request
export const requestRecipeSuggestionRequest = (
  data: IRequestRecipeSuggestionRequest
): RequestRecipeSuggestionRequestAction => ({
  type: REQUEST_RECIPE_SUGGESTION_REQUEST,
  payload: data,
});

export const requestRecipeSuggestionSuccess = (
  data: IRequestRecipeSuggestionResponse
): RequestRecipeSuggestionSuccessAction => ({
  type: REQUEST_RECIPE_SUGGESTION_SUCCESS,
  payload: data,
});

export const requestRecipeSuggestionError = (
  error: Error
): RequestRecipeSuggestionErrorAction => ({
  type: REQUEST_RECIPE_SUGGESTION_ERROR,
  payload: error,
});

export const cancelSearchRecipe = (): any => ({
  type: CANCEL_RECIPE_SUGGESTION_REQUEST,
});

// get list recipe request by ingredients and flavor items
export const fetchRecipeSuggestionRequest = (
  data: IFetchRecipeSuggestionRequest
): IFetchRecipeSuggestionRequestAction => ({
  type: FETCH_RECIPE_SUGGESTION_REQUEST,
  payload: data,
});

export const fetchRecipeSuggestionSuccess = (
  data: IFetchRecipeSuggestionResponse
): IFetchRecipeSuggestionSuccessAction => ({
  type: FETCH_RECIPE_SUGGESTION_SUCCESS,
  payload: data,
});

export const fetchRecipeSuggestionError = (
  error: Error
): IFetchRecipeSuggestionErrorAction => ({
  type: FETCH_RECIPE_SUGGESTION_ERROR,
  payload: error,
});

// get list recipe request by ingredients and flavor items
export const reloadRecipeSuggestionRequest = (
  data: IFetchRecipeSuggestionRequest & {callback?: any}
): IReloadRecipeSuggestionRequestAction => ({
  type: RELOAD_RECIPE_SUGGESTION_REQUEST,
  payload: data,
});

export const reloadRecipeSuggestionSuccess = (
  data: IFetchRecipeSuggestionResponse
): IFetchRecipeSuggestionSuccessAction => ({
  type: RELOAD_RECIPE_SUGGESTION_SUCCESS,
  payload: data,
});

// get recipe detail
export const fetchRecipeDetailRequest = (
  data: IFetchRecipeDetailRequest
): IFetchRecipeDetailRequestAction => ({
  type: FETCH_RECIPE_DETAIL_REQUEST,
  payload: data,
});

export const fetchRecipeDetailSuccess = (
  data: IFetchRecipeDetailResponse
): IFetchRecipeDetailSuccessAction => ({
  type: FETCH_RECIPE_DETAIL_SUCCESS,
  payload: data,
});

export const fetchRecipeDetailError = (
  error: Error
): IFetchRecipeDetailErrorAction => ({
  type: FETCH_RECIPE_DETAIL_ERROR,
  payload: error,
});

export const resetRecipe = (): IResetRecipeAction => ({
  type: RESET_RECIPE_SUGGESSTION,
});

export const updateFavorite = (
  data: IUpdateFavorite
): IUpdateFavoriteAction => ({
  type: UPDATE_FAVORITE,
  payload: data,
});

export const searchRecipeRequest = (
  data: any
): ISearchRecipeRequestAction => ({
  type: SEARCH_RECIPE_REQUEST,
  payload: data,
});

export const searchRecipeSuccess = (
  data: any
): ISearchRecipeSuccessAction => ({
  type: SEARCH_RECIPE_SUCCESS,
  payload: data,
});

export const searchRecipeError = (
  error: Error
): ISearchRecipeErrorAction => ({
  type: SEARCH_RECIPE_ERROR,
  payload: error,
});

export const resetSearchRecipe = (): IResetSearchRecipeAction=> ({
  type: RESET_SEARCH_RECIPE,
});

export const searchAiRecipeRequest = (
  data: any
): ISearchAiRecipeRequestAction => ({
  type: SEARCH_AI_RECIPE_REQUEST,
  payload: data,
});

export const searchAiRecipeSuccess = (
  data: any
): ISearchAiRecipeSuccessAction => ({
  type: SEARCH_AI_RECIPE_SUCCESS,
  payload: data,
});

export const searchAiRecipeError = (
  error: Error
): ISearchAiRecipeErrorAction => ({
  type: SEARCH_AI_RECIPE_ERROR,
  payload: error,
});
